// Referee-capture helpers. A `?ref=CODE` on any landing URL is persisted to a
// cookie so it survives the OAuth redirect round-trip (the referrer code can't
// ride the OAuth `state` unless we stash it first). Read at registration time
// (email/password + social) and cleared once a registration succeeds.

const REFERRAL_COOKIE = 'aceb_ref';
const REFERRAL_MAX_AGE_DAYS = 30;

// Server-generated codes are 8 alphanumerics; usernames are the only other
// shape. Cap length and restrict charset so a hostile `?ref=` can't smuggle
// anything into the cookie or downstream payload.
const isPlausibleCode = (value: string): boolean =>
  /^[A-Za-z0-9_-]{1,64}$/.test(value);

export function captureReferralFromUrl(): void {
  if (typeof window === 'undefined') return;
  const params = new URLSearchParams(window.location.search);
  const ref = params.get('ref');
  if (!ref || !isPlausibleCode(ref)) return;

  const maxAge = REFERRAL_MAX_AGE_DAYS * 24 * 60 * 60;
  document.cookie = `${REFERRAL_COOKIE}=${encodeURIComponent(ref)}; path=/; max-age=${maxAge}; SameSite=Lax`;
}

export function readReferralCookie(): string | undefined {
  if (typeof document === 'undefined') return undefined;
  const match = document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${REFERRAL_COOKIE}=`));
  if (!match) return undefined;
  const value = decodeURIComponent(match.slice(REFERRAL_COOKIE.length + 1));
  return isPlausibleCode(value) ? value : undefined;
}

export function clearReferralCookie(): void {
  if (typeof document === 'undefined') return;
  document.cookie = `${REFERRAL_COOKIE}=; path=/; max-age=0; SameSite=Lax`;
}
